import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Grid } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const ModalSection = styled("section")(() => ({
  width: "100%",
}));

const UploadBox = styled("div")(() => ({
  backgroundColor: colors.gray50,
  borderRadius: "12px",
  display: "flex",
  justifyContent: "center",
  padding: "12px 16px",
}));

export const UploadSection = styled(UploadBox)(() => ({
  height: "140px",
  flexDirection: "column",
  alignItems: "center",
  cursor: "pointer",
}));

export const UploadedSection = styled(UploadBox)(() => ({
  height: "48px",
  flexDirection: "row",
  justifyContent: "space-between",
  "& div": {
    display: "flex",
    alignItems: "center",
  },
}));

export const UploadTitle = styled("span")(() => ({
  marginTop: "4px",
  color: colors.brandBlue500,
  textAlign: "center",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "150%",
  fontFamily: "Manrope",
}));

export const UploadDescription = styled("span")(() => ({
  color: colors.gray500,
  textAlign: "center",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "150%",
  fontFamily: "Manrope",
}));

export const UploadFilenameBox = styled("div")(() => ({
  maxWidth: "312px",
}));

export const UploadFilename = styled("span")(() => ({
  color: colors.gray600,
  textAlign: "center",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "150%",
  fontFamily: "Manrope",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  marginLeft: "12px",
}));

export const DeleteButton = styled("div")(() => ({
  cursor: "pointer",
  "& hover": {
    opacity: 0.6,
  },
}));

export const Row = styled(Grid)(() => ({}));

const styles = makeStyles(() => ({
  modal: {
    maxWidth: "676px !important",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    "& > label": {
      marginBottom: 0,
      marginRight: 8,
    },
  },
}));

export default styles;
